import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CoreUiModule, CustomDateAdapter } from '@lla-platform/core/core-ui'
import { MainHeaderComponent } from './components/main-header/main-header.component'
import { RouterModule } from '@angular/router'
import { SvgIconComponent } from '@ngneat/svg-icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { ProfileLayoutComponent } from './components/profile-layout/profile-layout.component'
import { MatTableModule } from '@angular/material/table'
import { MatSortModule } from '@angular/material/sort'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MainMenuComponent } from './components/main-menu/main-menu.component'
import { TableHeaderComponent } from './components/table-header/table-header.component'
import { AddBookmarkDialogComponent } from './components/add-bookmark-dialog/add-bookmark-dialog.component'
import { InvoiceInfoComponent } from './components/invoice-info/invoice-info.component'
import { LineChartComponent } from './components/line-chart/line-chart.component'
import { ShopsSelectorComponent } from './components/shops-selector/shops-selector.component'
import { InvoiceInfoDialogComponent } from './components/invoice-info-dialog/invoice-info-dialog.component'
import { TimePeriodFilterComponent } from './components/time-period-filter/time-period-filter.component'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'
import {
  DefaultMatCalendarRangeStrategy,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerModule
} from '@angular/material/datepicker'
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import { RangeDatePickerComponent } from './components/range-date-picker/range-date-picker.component'
import { RangeDatePickerFilterComponent } from './components/range-date-picker-filter/range-date-picker-filter.component'
import { PillComponent } from './components/pill/pill.component'
import { TableFilterComponent } from './widgets/table-filter/table-filter.component'
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component'
import { TableFiltersListComponent } from './widgets/table-filter/components/table-filters-list/table-filters-list.component'
import { TableFiltersHeaderComponent } from './widgets/table-filter/components/table-filters-header/table-filters-header.component'
import { InvoiceInfoCellComponent } from './components/invoice-info-cell/invoice-info-cell.component'
import { PageTitleComponent } from './components/page-title/page-title.component'
import { PageOverviewComponent } from './components/page-overview/page-overview.component'
import { PageOverviewInvoicesCountComponent } from './components/page-overview-invoices-count/page-overview-invoices-count.component'
import { FilterDialogComponent } from './components/filter-dialog/filter-dialog.component'
import { ItemsSelectorFilterComponent } from './components/items-selector-filter/items-selector-filter.component'
import { ConfirmSimpleModeDialogComponent } from './widgets/table-filter/components/confirm-simple-mode-dialog/confirm-simple-mode-dialog.component'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CollapsableTitleComponent } from './components/collapsable-title/collapsable-title.component'
import { LlaTippyDirective } from './directives/lla-tippy.directive'
import { ScrollAxisLockDirective } from './directives/scroll-axis-lock.directive'
import { ShopsSelectorMenuComponent } from './components/shops-selector-menu/shops-selector-menu.component'
import { ContactMapComponent } from './components/contact-map/contact-map.component'
import { NgxSliderModule } from '@angular-slider/ngx-slider'
import { AttendanceEmployeeDialogComponent } from './components/attendance-employee-dialog/attendance-employee-dialog.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { SidemenuBottomSheetComponent } from './components/sidemenu-bottom-sheet/sidemenu-bottom-sheet.component'
import { DropdownBottomSheetComponent } from './components/dropdown-bottom-sheet/dropdown-bottom-sheet.component'
import { BottomSheetSortComponent } from './components/bottom-sheet-sort/bottom-sheet-sort.component'
import { RangeDatePickerDialogComponent } from './components/range-date-picker-dialog/range-date-picker-dialog.component'
import { WeekSelectorComponent } from './components/week-selector/week-selector.component'
import { WeekSelectorDialogComponent } from './components/week-selector-dialog/week-selector-dialog.component'
import { WeekSelectorFilterComponent } from './components/week-selector-filter/week-selector-filter.component'
import { DateAdapter } from '@angular/material/core'
import { StackedDoubleGaugeComponent } from './components/stacked-double-gauge/stacked-double-gauge.component'
import { StackedBarChartComponent } from './components/stacked-bar-chart/stacked-bar-chart.component'
import { WaterfallChartComponent } from './components/waterfall-chart/waterfall-chart.component'
import { MonthSelectorComponent } from './components/month-selector/month-selector.component'
import { MonthSelectorFilterComponent } from './components/month-selector-filter/month-selector-filter.component'
import { MonthSelectorDialogComponent } from './components/month-selector-dialog/month-selector-dialog.component'
import { DatePickerComponent } from './components/date-picker/date-picker.component'
import { DatePickerFilterComponent } from './components/date-picker-filter/date-picker-filter.component'
import { DatePickerDialogComponent } from './components/date-picker-dialog/date-picker-dialog.component'
import { BaseChartDirective } from 'ng2-charts'
import { TrendLineChartComponent } from './components/trend-line-chart/trend-line-chart.component'
import { TrendViewComponent } from './components/trend-view/trend-view.component'
import { OverviewFiltersHeaderComponent } from './widgets/overview-filter/components/overview-filters-header/overview-filters-header.component'
import { OverviewFiltersItemComponent } from './widgets/overview-filter/components/overview-filters-item/overview-filters-item.component'
import { OverviewFiltersListComponent } from './widgets/overview-filter/components/overview-filters-list/overview-filters-list.component'
import { OverviewFiltersDialogComponent } from './widgets/overview-filter/components/overview-filters-dialog/overview-filters-dialog.component'
import { SelectorCardComponent } from './components/selector-card/selector-card.component'
import { AnnouncementsMenuComponent } from './components/announcements-menu/announcements-menu.component'
import { AnnouncementListItemComponent } from './components/announcement-list-item/announcement-list-item.component'
import { LoudAnnouncementDialogComponent } from './components/loud-announcement-dialog/loud-announcement-dialog.component'
import { LoudAnnouncementsHostComponent } from './components/loud-announcements-host/loud-announcements-host.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreUiModule,
    RouterModule,
    SvgIconComponent,
    MatMenuModule,
    MatIconModule,
    DragDropModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTooltipModule,
    NgxSliderModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    BaseChartDirective
  ],
  declarations: [
    AddBookmarkDialogComponent,
    MainHeaderComponent,
    ProfileLayoutComponent,
    MainMenuComponent,
    TableHeaderComponent,
    InvoiceInfoComponent,
    LineChartComponent,
    ShopsSelectorComponent,
    InvoiceInfoDialogComponent,
    TimePeriodFilterComponent,
    RangeDatePickerComponent,
    RangeDatePickerFilterComponent,
    PillComponent,
    DropdownMenuComponent,
    ConfirmSimpleModeDialogComponent,
    TableFiltersListComponent,
    TableFiltersHeaderComponent,
    TableFilterComponent,
    InvoiceInfoCellComponent,
    PageTitleComponent,
    PageOverviewComponent,
    PageOverviewInvoicesCountComponent,
    FilterDialogComponent,
    ItemsSelectorFilterComponent,
    CollapsableTitleComponent,
    ShopsSelectorMenuComponent,
    ContactMapComponent,
    AttendanceEmployeeDialogComponent,
    SidemenuBottomSheetComponent,
    DropdownBottomSheetComponent,
    BottomSheetSortComponent,
    RangeDatePickerDialogComponent,
    WeekSelectorComponent,
    WeekSelectorDialogComponent,
    WeekSelectorFilterComponent,
    MonthSelectorComponent,
    MonthSelectorFilterComponent,
    MonthSelectorDialogComponent,
    StackedDoubleGaugeComponent,
    StackedBarChartComponent,
    WaterfallChartComponent,
    DatePickerComponent,
    DatePickerFilterComponent,
    DatePickerDialogComponent,
    LlaTippyDirective,
    ScrollAxisLockDirective,
    OverviewFiltersHeaderComponent,
    OverviewFiltersItemComponent,
    OverviewFiltersListComponent,
    OverviewFiltersDialogComponent,
    SelectorCardComponent,
    AnnouncementsMenuComponent,
    AnnouncementListItemComponent,
    LoudAnnouncementDialogComponent,
    LoudAnnouncementsHostComponent,
    TrendLineChartComponent,
    TrendViewComponent
  ],
  exports: [
    TrendLineChartComponent,
    TrendViewComponent,
    MainHeaderComponent,
    ProfileLayoutComponent,
    MainMenuComponent,
    TableHeaderComponent,
    InvoiceInfoComponent,
    LineChartComponent,
    ShopsSelectorComponent,
    InvoiceInfoDialogComponent,
    TimePeriodFilterComponent,
    RangeDatePickerComponent,
    RangeDatePickerFilterComponent,
    PillComponent,
    DropdownMenuComponent,
    TableFiltersListComponent,
    TableFiltersHeaderComponent,
    TableFilterComponent,
    InvoiceInfoCellComponent,
    PageTitleComponent,
    PageOverviewComponent,
    PageOverviewInvoicesCountComponent,
    FilterDialogComponent,
    ItemsSelectorFilterComponent,
    CollapsableTitleComponent,
    ShopsSelectorMenuComponent,
    ContactMapComponent,
    AttendanceEmployeeDialogComponent,
    BottomSheetSortComponent,
    WeekSelectorComponent,
    WeekSelectorFilterComponent,
    MonthSelectorComponent,
    MonthSelectorFilterComponent,
    StackedDoubleGaugeComponent,
    StackedBarChartComponent,
    WaterfallChartComponent,
    DatePickerComponent,
    DatePickerFilterComponent,
    LlaTippyDirective,
    ScrollAxisLockDirective,
    OverviewFiltersHeaderComponent,
    OverviewFiltersItemComponent,
    OverviewFiltersListComponent,
    SelectorCardComponent,
    AnnouncementsMenuComponent,
    AnnouncementListItemComponent,
    LoudAnnouncementsHostComponent
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy
    }
  ]
})
export class CoreFeatureModule {}
